// Witness GraphQL queries

import { gql } from "@apollo/client"

export const GET_CURRENT_WITNESSES = gql`
  query GetCurrentWitnesses {
    getCurrentWitnesses {
      id
      contactID
      firstName
      lastName
      displayName
      email
      companyName
      title
      jobTitle
      gender
      phone1
      phone2
      phone3
      active
      businessAccount
      languageOrLocale
    }
  }
`

export const GET_ALL_WITNESSES = gql`
  query GetAllWitnesses($fresh: Boolean) {
    getAllWitnesses(fresh: $fresh) {
      id
      contactID
      firstName
      lastName
      displayName
      email
      companyName
      title
      jobTitle
      gender
      phone1
      phone2
      phone3
      active
      businessAccount
      languageOrLocale
    }
  }
`

export const SEARCH_WITNESSES = gql`
  query SearchWitnesses($searchTerm: String!, $limit: Int) {
    searchWitnesses(searchTerm: $searchTerm, limit: $limit) {
      id
      contactID
      firstName
      lastName
      displayName
      email
      companyName
      title
      jobTitle
      gender
      phone1
      phone2
      phone3
      active
      businessAccount
      languageOrLocale
    }
  }
`